import {SuccessEvent} from "../../../../../common/ts/core/http";
import {WhitelabelEvent, WhitelabelEventWithPayload} from "../../../../../common/ts/events/Events";

interface SaveWebPushAlertRequestedPayload {
    search: string,
    subscription: PushSubscription,
    successEvent?: SuccessEvent,
}

export class SaveWebPushAlertRequestedEvent implements WhitelabelEventWithPayload<SaveWebPushAlertRequestedPayload> {
    payload: SaveWebPushAlertRequestedPayload;
    type: string;
    static readonly TYPE: string = 'save-web-push-alert-requested';

    constructor(payload: SaveWebPushAlertRequestedPayload) {
        this.type = SaveWebPushAlertRequestedEvent.TYPE;
        this.payload = payload;
    }
}

interface ShowWebPushRequestedPayload {
    search: string,
    pageviewId: string,
    device: string,
    showGoogleOneTapAfter: boolean,
}

export class ShowWebPushRequestedEvent implements WhitelabelEventWithPayload<ShowWebPushRequestedPayload> {
    payload: ShowWebPushRequestedPayload;
    type: string;
    static readonly TYPE: string = 'show-web-push-requested';

    constructor(payload: ShowWebPushRequestedPayload) {
        this.type = ShowWebPushRequestedEvent.TYPE;
        this.payload = payload;
    }
}
